"use client";

import { SignIn } from "@clerk/nextjs";

export default function Page() {
  return (
    // eslint-disable-next-line max-len
    <main className="flex min-h-screen flex-col items-center justify-start pt-10">
      <SignIn path="/login" />
    </main>
  );
}
